<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar color="#f0e633"
                 dark
                 extended
                 flat
      >
      </v-toolbar>

      <v-card class="mx-auto"
              max-width="1100"
              style="margin-top: -64px;"
      >
        <v-toolbar flat>
          <v-toolbar-title class="black--text">Productos</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar.."
              single-line
              hide-details
              class="mr-2"
          ></v-text-field>

          <v-btn class="mr-1"
                 dark
                 @click.stop="showAddProductModal()"
          >
            <v-icon>mdi-plus</v-icon>
            Nuevo producto
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text>
          <v-data-table
              :loading="areProductsLoading()"
              loading-text="Cargando... Por favor espere"
              :headers="headers"
              :items="products"
              :search="search"
              sort-by="name"
              :footer-props="pagination"
              class="elevation-1"
          >

            <template v-slot:item.price="{ item }">
              {{ item.price | currency }}
            </template>

            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          @click.stop="showDetailsProductModal(item)"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>

              <v-tooltip bottom
                         v-if="isStatusActive(item)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="orange"
                          @click.stop="showStatusConfirmModal(item, 'inactive')"
                  >
                    mdi-eye-remove
                  </v-icon>
                </template>
                <span>Desactivar</span>
              </v-tooltip>

              <v-tooltip bottom
                         v-else-if="isStatusInactive(item)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="green"
                          @click.stop="showStatusConfirmModal(item, 'active')"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>Activar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="teal"
                          @click.stop="showEditProductModal(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom
                         v-if="isStatusDeleted(item)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="secondary"
                          @click.stop="showStatusConfirmModal(item, 'active')"
                  >
                    mdi-restore
                  </v-icon>
                </template>
                <span>Restaurar</span>
              </v-tooltip>

              <v-tooltip bottom
                         v-else
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          @click.stop="showStatusConfirmModal(item, 'deleted')"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary"
                     @click="fetchProducts()"
              >RECARGAR
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>

    <!-- MODAL ADD PRODUCT -->
    <v-dialog v-model="modal.showAddProduct"
              width="900"
              persistent
    >
      <v-card>
        <v-toolbar color="transparent">

          <v-btn icon
                 color="black"
                 @click="hideAddProductModal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>Agregar Nuevo Producto</v-toolbar-title>
        </v-toolbar>

        <product-form :merchant-id="getMerchantId()"
                      v-on:product:saved="addOrEditProductSaved($event)"
                      v-on:product:canceled="hideAddProductModal()"
                      :newCategories="productCategories"
        />
      </v-card>
    </v-dialog>

    <!-- MODAL EDIT PRODUCT -->
    <v-dialog v-model="modal.showEditProduct"
              width="900"
              persistent
    >
      <v-card>
        <v-toolbar color="transparent">

          <v-btn icon
                 color="black"
                 @click="hideEditProductModal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>{{ editProduct.name }}</v-toolbar-title>
        </v-toolbar>

        <product-form :product="editProduct"
                      is-updating
                      :merchant-id="getMerchantId()"
                      v-on:product:saved="addOrEditProductSaved($event)"
                      v-on:product:canceled="hideEditProductModal()"
                      :newCategories="productCategories"
        />
      </v-card>
    </v-dialog>

    <!-- MODAL DETAILS PRODUCT -->
    <v-dialog
        v-model="modal.showDetailProduct"
        width="600"
    >
      <v-card>
        <v-toolbar color="transparent">

          <v-btn icon
                 color="black"
                 @click="hideDetailsProductModal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>{{ detailProduct.name }}</v-toolbar-title>
        </v-toolbar>

        <v-img :src="detailProduct.imageUrl"
               height="200"
        ></v-img>

        <v-card-text>
          <v-row dense>
            <v-col cols="6">
              <p class="body-1 font-weight-bold">Categoria</p>
              <div class="my-2 black--text">{{ detailProduct.category }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">Descripción</p>
              <div class="my-2 black--text">{{ detailProduct.description }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">Precio</p>
              <div class="my-2 black--text">{{ detailProduct.price | currency }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">Costo de envío</p>
              <div class="my-2 black--text">{{ detailProduct.deliveryCost | currency }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">Estado</p>
              <div class="my-2 black--text">{{ translateStatus(detailProduct.status) }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">¿Tiene combo?</p>
              <div class="my-2 black--text">{{ translateCombo(detailProduct) }}</div>
            </v-col>

            <v-col cols="6"
                   v-if="hasComboActive(detailProduct)"
            >
              <p class="body-1 font-weight-bold">Precio del combo</p>
              <div class="my-2 black--text">{{ detailProduct.comboPrice | currency }}</div>
            </v-col>

            <v-col cols="6"
                   v-if="hasComboActive(detailProduct)"
            >
              <p class="body-1 font-weight-bold">Detalles del combo</p>
              <div class="my-2 black--text">{{ detailProduct.comboNotes }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">Cantidad de Likes</p>
              <div class="my-2 black--text">{{ detailProduct.likes }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">Cantidad de ordenes</p>
              <div class="my-2 black--text">{{ detailProduct.orders }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">Fecha de creación</p>
              <div class="my-2 black--text">{{ formatDate(detailProduct.createdAt) }}</div>
            </v-col>

            <v-col cols="6">
              <p class="body-1 font-weight-bold">Fecha de actualización</p>
              <div class="my-2 black--text">{{ formatDate(detailProduct.updatedAt) }}</div>
            </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL CONFIRM STATUS -->
    <v-dialog
        v-model="modal.showConfirmStatus"
        width="320"
        persistent
    >
      <v-card>
        <v-card-title class="headline black--text">
          Confirmar
        </v-card-title>

        <v-card-text class="red--text body-1">
          ¿Seguro que desea cambiar a <b>{{ translateStatus(this.statusProduct.status) }}</b> {{
            getStatusProductName()
          }}?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              dark
              @click="hideStatusConfirmModal()"
          >
            No
          </v-btn>

          <v-btn
              dark
              color="red"
              :loading="sending.status"
              @click="changeStatus()"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Parse from "parse"
import ProductForm from "@/components/forms/ProductForm"

export default {
  name: "Products",
  components: {
    ProductForm,
  },
  data: () => {
    return {
      products: [],
      headers: [
        {text: 'Categoria', value: 'productCategory.attributes.name'},
        {text: 'Nombre', value: 'name'},
        {text: 'Precio', value: 'price'},
        {text: 'Fecha', value: 'createdAt'},
        {text: 'Acción', value: 'actions', sortable: false},
      ],
      loading: {
        products: {
          active: true,
          inactive: true,
          deleted: true,
        },
      },
      modal: {
        showDetailProduct: false,
        showConfirmStatus: false,
        showEditProduct: false,
        showAddProduct: false
      },
      sending: {
        product: false,
        status: false,
      },
      editProduct: {
        name: '',
        category: '',
        imageUrl: '',
        price: '',
        description: '',
        status: '',
        deliveryCost: 0,
        comboOption: false,
        comboNotes: '',
        comboPrice: 0,
        productCategory: ''
      },
      detailProduct: {},
      statusProduct: {},
      pagination: {
        'items-per-page-options': [50, 60, 70, 100, -1]
      },
      search: '',
      productCategories: [],
    }
  },
  mounted() {
    this.getCategories()
    this.fetchProducts()
  },
  methods: {
    getMerchantId() {
      return this.$route.params.store_id
    },

    isStatusActive(product) {
      return product.status === 'active'
    },

    isStatusInactive(product) {
      return product.status === 'inactive'
    },

    isStatusDeleted(product) {
      return product.status === 'deleted'
    },

    translateCombo(product) {
      return this.hasComboActive(product) ? 'Si' : 'No'
    },

    hasComboActive(product) {
      return product.comboOption === true
    },

    getStatusProductName() {
      if (this.statusProduct && this.statusProduct.product !== undefined) {
        return this.statusProduct.product.name
      }

      return ''
    },

    changeStatus() {
      let params = {
        id: this.statusProduct.product.id,
        status: this.statusProduct.status
      }

      this.changeSendingStatusToTrue()
      this.runParseCloud('updatePromoStatus', params)
          .then(response => {
            this.hideStatusConfirmModal()
            this.resetStatusProduct()
            this.addOrEditProductSaved({
              id: response.id,
              status: response.attributes.status
            })
          })
          .catch(error => this.showErrorMessage('Error', error.message))
          .finally(() => this.changeSendingStatusToFalse())
    },

    resetStatusProduct() {
      this.statusProduct = {}
    },

    changeSendingStatusToTrue() {
      this.sending.status = true
    },

    changeSendingStatusToFalse() {
      this.sending.status = false
    },

    translateStatus(status) {

      if (status === 'active') {
        return 'Activado'
      }

      if (status === 'inactive') {
        return 'Desactivado'
      }

      if (status === 'deleted') {
        return 'Borrado'
      }

      return ''
    },

    addOrEditProductSaved(product) {
      let productIndex = this.findProductIndexById(product.id)

      if (productIndex === -1){
        this.products.push(product)
        this.hideAddProductModal()
      } else{
        Object.assign(this.products[productIndex], product)
        this.hideEditProductModal()
      }
    },

    findProductIndexById(productId) {
      return this.products.findIndex(value => value.id === productId)
    },

    showStatusConfirmModal(product, status) {
      this.statusProduct.product = product
      this.statusProduct.status = status
      this.modal.showConfirmStatus = true
    },

    hideStatusConfirmModal() {
      this.modal.showConfirmStatus = false
    },

    showDetailsProductModal(product) {
      this.detailProduct = product
      this.modal.showDetailProduct = true
    },

    hideDetailsProductModal() {
      this.modal.showDetailProduct = false
    },

    showEditProductModal(product) {
      this.fillEditProduct(product)
      this.modal.showEditProduct = true
    },

    fillEditProduct(product) {
      this.editProduct.id = product.id
      this.editProduct.name = product.name
      this.editProduct.category = product.category
      this.editProduct.imageUrl = product.imageUrl
      this.editProduct.price = product.price
      this.editProduct.description = product.description
      this.editProduct.deliveryCost = product.deliveryCost
      this.editProduct.comboOption = product.comboOption
      this.editProduct.comboNotes = product.comboNotes
      this.editProduct.comboPrice = product.comboPrice
      this.editProduct.status = product.status
      this.editProduct.superCategory = product.superCategory
      this.editProduct.productCategory = product.productCategory
    },

    hideEditProductModal() {
      this.modal.showEditProduct = false
    },

    showAddProductModal() {
      this.modal.showAddProduct = true
    },

    hideAddProductModal() {
      this.modal.showAddProduct = false
    },

    clearProducts() {
      this.products = []
    },

    fetchProducts() {
      this.clearProducts()
      this.fetchActiveProducts()
      this.fetchInactiveProducts()
      this.fetchDeletedProducts()
    },

    fetchActiveProducts() {
      let params = {
        id: this.getMerchantId(),
        status: 'active'
      }

      this.runParseCloud('getMyProductsBO', params)
          .then(response => {
            if (response.length > 0) {
              
              this.products.push(...this.transformProductsResponseToProducts(response))
            }
          })
          .catch(error => this.showErrorMessage('Error', error.message))
          .finally(() => this.setLoadingActiveProductsAsFalse())
    },

    fetchInactiveProducts() {
      let params = {
        id: this.getMerchantId(),
        status: 'inactive'
      }

      this.runParseCloud('getMyProductsBO', params)
          .then(response => {
            if (response.length > 0) {
              this.products.push(...this.transformProductsResponseToProducts(response))
            }
          })
          .catch(error => this.showErrorMessage('Error', error.message))
          .finally(() => this.setLoadingInactiveProductsAsFalse())
    },

    fetchDeletedProducts() {
      let params = {
        id: this.getMerchantId(),
        status: 'deleted'
      }

      this.runParseCloud('getMyProductsBO', params)
          .then(response => {
            if (response.length > 0) {
              this.products.push(...this.transformProductsResponseToProducts(response))
            }
          })
          .catch(error => this.showErrorMessage('Error', error.message))
          .finally(() => this.setLoadingDeletedProductsAsFalse())
    },

    areProductsLoading() {
      return this.loading.products.active === true && this.loading.products.inactive === true && this.loading.products.deleted === true
    },

    transformProductsResponseToProducts(response) {
      return response.map(value => {
        return {
          id: value.id,
          name: value.attributes.name,
          category: value.attributes.category,
          imageUrl: value.attributes.imageUrl,
          price: value.attributes.price,
          description: value.attributes.description,
          deliveryCost: value.attributes.deliveryCost,
          comboOption: value.attributes.comboOption,
          comboNotes: value.attributes.comboNotes,
          comboPrice: value.attributes.comboPrice,
          status: value.attributes.status,
          superCategory: value.attributes.superCategory,
          createdAt: value.attributes.createdAt,
          productCategory: value.attributes.productCategory
        }
      })
    },

    formatDate(date, format = 'lll') {
      return this.$moment(date).format(format)
    },

    setLoadingActiveProductsAsFalse() {
      this.loading.products.active = false
    },

    setLoadingInactiveProductsAsFalse() {
      this.loading.products.inactive = false
    },

    setLoadingDeletedProductsAsFalse() {
      this.loading.products.deleted = false
    },

    runParseCloud(name, params, options = {}) {
      return Parse.Cloud.run(name, params, options)
    },

    showErrorMessage(title, message) {
      this.$snotify.error(message, title, {timeout: 4000, preventDuplicates: true});
    },

    async getCategories () {
          const params = {
              id: this.$route.params.store_id
          }
        try {
          let productCategories = await Parse.Cloud.run("getMyCategoriesBO", params);
          this.productCategories = productCategories
          //eslint-disable-next-line
          //console.log(this.products);
          
        } catch (error) {
          this.$snotify.error(`${error}` , 'Categorías', {
            timeout: 4000,
            preventDuplicates: true
          });
        }
        
      },
  }
}
</script>